<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">Service Requests</h1>
      <router-link to="/request/service/add" class="button is-primary is-small is-uppercase">Add</router-link>
    </div>
    <div class="box" style="margin-top: 12px;">
      <component-search></component-search>
      <component-filters></component-filters>
    </div>
    <service-table class="is-hidden-mobile"></service-table>
    <service-list class="is-hidden-tablet"></service-list>
    <app-paginate module="service"></app-paginate>
  </div>
</template>
<script>
import ComponentSearch from "./components/search";
import ComponentFilters from "./components/filters";
import ServiceTable from "./components/service-table";
import ServiceList from "./components/service-list";
export default {
  components: {
    ComponentSearch,
    ComponentFilters,
    ServiceTable,
    ServiceList
  }
};
</script>
<style lang="scss" scoped>
.is-flex {
  .view-title {
    flex-basis: 0;
    flex-grow: 1;
  }
  .add-button {
    margin-top: 12px;
  }
}
</style>
